export type LupsEventStatusFilter = 'all' | 'processed' | 'unprocessed';
export type LupsEventTypeFilter = 'all' | 'payment_succeeded' | 'payment_failed';

export interface LupsEventListItem {
  idEvento: string;
  lupsRequestId: string | null;
  orderUuid: string | null;
  eventType: string;
  montoCobrado: string | null;
  timestampEvento: string;
  processedAt: string | null;
  createdAt: string;
}

export interface LupsEventDetail extends LupsEventListItem {
  payloadRaw: Record<string, unknown>;
  paymentRequest: {
    id: string;
    advanceRequestId: string;
    installmentDetailId: string;
    sendStatus: string;
    pacActive: boolean;
    monto: string;
  } | null;
}

export interface LupsEventsListResult {
  page: number;
  pageSize: number;
  total: number;
  items: LupsEventListItem[];
}

export interface LupsEventStats {
  total24h: number;
  unprocessed: number;
  unprocessedRecent: number;
  processed24h: number;
  succeeded24h: number;
  failed24h: number;
  byEventType: { eventType: string; count: number }[];
  recent: LupsEventListItem[];
}

export const EVENT_TYPE_LABELS: Record<string, string> = {
  payment_succeeded: 'Pago exitoso',
  payment_failed: 'Pago fallido',
};

export const EVENT_TYPE_TONE: Record<string, { dot: string; text: string; bg: string; ring: string }> = {
  payment_succeeded: {
    dot: 'bg-emerald-500',
    text: 'text-emerald-700 dark:text-emerald-300',
    bg: 'bg-emerald-50 dark:bg-emerald-950/30',
    ring: 'ring-emerald-200 dark:ring-emerald-900/50',
  },
  payment_failed: {
    dot: 'bg-rose-500',
    text: 'text-rose-700 dark:text-rose-300',
    bg: 'bg-rose-50 dark:bg-rose-950/30',
    ring: 'ring-rose-200 dark:ring-rose-900/50',
  },
};
